<template>
  <div class="c-monitor">
    <!-- filter -->
    <prewarn-filter placeholder="请输入规则ID或者名称" @on-change="filterData" @on-search="searchFilterData" />
    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <prewarn-table :loading="loading" :height="tableHeight" :data="tableList" :columns="tableCol" @on-refresh="getData" />
        <Page
          show-total
          show-sizer
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page pager"
          size="small"
        />
      </Viewport>
    </div>
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/adcountwarn_column'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray } from '@/common/js/utils'
import { getAdcountData } from '@/api/tools.model'
import PrewarnFilter from './components/adcount-filter'
import PrewarnTable from './components/adcount-table'

export default {
  name: 'monitor',
  mixins: [mixin],
  components: { PrewarnFilter, PrewarnTable },
  data() {
    return { tableHeight: 330 }
  },
  methods: {
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getAdcountData(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list.map((ret) => {
              const { ruleMsg } = ret
              const monitor = ruleMsg.split(';')
              if (isArray(monitor) && monitor.length) {
                const [dataRange, ...ruleMsgInfo] = monitor
                if (dataRange) ret.dataRange = dataRange
                ret.ruleMsg = ruleMsgInfo
              }
              return ret
            })
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    setLocalPage(size) {
      setLocal('MONITOR_PAGESIZE', size)
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('MONITOR_PAGESIZE')) || 20
    this.tableCol = columns
    this.sort = 'create_time'
    this.order = 'desc'
  }
}
</script>
<style lang="scss" scoped>
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
